import { render, staticRenderFns } from "./UpdateStatus.vue?vue&type=template&id=24cba188&scoped=true"
import script from "./UpdateStatus.vue?vue&type=script&lang=js"
export * from "./UpdateStatus.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatus.vue?vue&type=style&index=0&id=24cba188&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cba188",
  null
  
)

export default component.exports